import PARENT from '../types';

export const SET_TAIL_TYPE = `${PARENT}/SET_TAIL_TYPE`;
